(function($, Drupal, once){
  Drupal.behaviors['adobe-launch-data_collection'] = {
    attach: function (context) {
      $(once('adobe-launch-data_collection', 'body', context)).each(function () {

        console.log('Adobe Launch data collection');
        // console.log(drupalSettings.tealium.tealium.utagData);

        if (typeof drupalSettings.intactData !== 'undefined'){
          var intactData = drupalSettings.intactData;
          var region_name = 'Unknown';
          if (document.cookie.indexOf("region=") >= 0) {
            // The region cookie is present. It trumps all
            region_name = getCookieRegion('region');
          }

          // userRegion = getRegion();
          // console.log("adobe-launch-data_collection", userRegion);

          window.appEventData.push({
            "event": "Page",
            "pageInfo": {
              "pageName": intactData.page_name.replace("&", "and"),
              "pageCategory": intactData.pageCategory,
              "pageStep": "0.0",
              "pageProduct": intactData.page_type,
              "pageVersion": "Responsive",
              "loginStatus": "0",
              "pageBusinessLine": "Personal",
              "chatAvailability": "1",
              "pageLanguage": intactData.language_name,
              "pageProvince": region_name,
            }
          });

          console.log(window.appEventData);

        } else {
          console.log('Could not find intact Data!');
        }

      });

    },
  };

})(jQuery, Drupal, once);
